import type { Meta, StoryObj } from '@storybook/angular';
import { expect } from 'storybook/test';
import { StoryblokIconWithTextComponent } from '../../app/content/modules/storyblok/components/storyblok-icon-with-text/storyblok-icon-with-text.component';
import { withStoryblokDecorators } from '../_utils/story-helpers';

const meta: Meta<StoryblokIconWithTextComponent> = {
  title: 'Storyblok/Icon With Text',
  component: StoryblokIconWithTextComponent,
  decorators: [...withStoryblokDecorators()],
  parameters: {
    docs: {
      description: {
        component: 'Storyblok icon with text component. Displays an icon alongside a title and HTML text content.',
      },
    },
  },
};

export default meta;
type Story = StoryObj<StoryblokIconWithTextComponent>;

export const Default: Story = {
  args: {
    icon: { filename: 'https://a.storyblok.com/f/106593/100x100/cc535ac665/bla-drue-tegning.jpg' },
    title: 'Fri fragt over 1.000 kr.',
    text: '<p>Vi tilbyder gratis levering på alle ordrer over 1.000 kr.</p>',
    _uid: 'sb-icon-text-1',
    component: 'icon_with_text',
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-icon-with-text')).toBeTruthy();
  },
};

export const WithColorTheme: Story = {
  args: {
    icon: { filename: 'https://a.storyblok.com/f/106593/100x100/f35c5f3002/gron-drue-tegning.jpg' },
    title: 'Kundeanmeldelser',
    text: '<p>Se hvad vores kunder siger om os.</p>',
    color_theme: { value: '#E91E63' },
    _uid: 'sb-icon-text-2',
    component: 'icon_with_text',
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-icon-with-text')).toBeTruthy();
  },
};

export const CustomIconSize: Story = {
  args: {
    icon: { filename: 'https://a.storyblok.com/f/106593/100x100/5f307117b7/begge-druer-tegning.jpg' },
    title: 'Vinsmagning',
    text: '<p>Book en vinsmagning med vores sommeliers.</p>',
    icon_width: '64',
    icon_height: '64',
    _uid: 'sb-icon-text-3',
    component: 'icon_with_text',
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-icon-with-text')).toBeTruthy();
  },
};

export const NoTitle: Story = {
  args: {
    icon: { filename: 'https://a.storyblok.com/f/106593/100x100/cc535ac665/bla-drue-tegning.jpg' },
    text: '<p>Se vores leveringsbetingelser for flere detaljer.</p>',
    _uid: 'sb-icon-text-4',
    component: 'icon_with_text',
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-icon-with-text')).toBeTruthy();
  },
};
